// eslint-disable-next-line no-restricted-imports
import lumonColors from '../../tailwind.config.lumon';

import { getZapposRebrandTailwindColor } from 'utils/rebrand/getZapposRebrandTailwindColor';

export const ZAPPOS_REBRAND_REPLACEMENT_COLORS = {
  '#e7f4ff': getZapposRebrandTailwindColor(lumonColors.yellow['50'])
} as const;
